import moment from 'moment'

export default {
  format: (date, format) => date != null ? moment(date).format(format) : ''
}